import {Button, Stack, Typography, useTheme} from '@mui/material';
import {AlertModal} from 'presentation/components';
import {ConsultProtocolsEnum, HomeEnum} from 'presentation/constants';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import Icon from 'presentation/icons';
import {RequestScheduleSucessModalProps} from './types';

const {successModal} = translations['pt-br'].privateFlow.bookingFlow.requestSchedule;

export const RequestScheduleSucessModal = ({open, protocol}: RequestScheduleSucessModalProps) => {
	const navigate = useNavigate();
	const {colors} = useTheme();
	const {isMobile} = useMediaQueries();

	return (
		<AlertModal
		slotProps={{
			paper: {
				style: {
					maxWidth: 420,
					margin: isMobile ? 16 : 'auto',
					flex: isMobile ? 1 : 'initial',
				},
			},
		}}
			subDescription={
				<Stack flexDirection={'row'} gap={1}>
					<Icon name="assignment-filled" color={colors.brand.primary.blue} size={20} />
					<Stack>
						<Typography variant="body1" color={'text.secondary'}>
							{successModal.protocolTitle}
						</Typography>
						<Typography variant="body1">{protocol}</Typography>
					</Stack>
				</Stack>
			}
			description={successModal.description}
			title={successModal.headerTitle}
			headerTitle={successModal.headerModalTitle}
			open={open}
			disableClose
			variant="success"
			footerContent={
				<Stack gap={1} width="100%">
					<Button
						variant="contained"
						size="large"
						onClick={() =>
							navigate(ConsultProtocolsEnum.CONSULT_PROTOCOLS, {replace: true})
						}
						fullWidth>
						{successModal.firstButton}
					</Button>
					<Button
						variant="outlined"
						size="large"
						onClick={() => navigate(HomeEnum.HOME_PAGE, {replace: true})}
						fullWidth>
						{successModal.secondButton}
					</Button>
				</Stack>
			}
		/>
	);
};
